import { PhoneOff } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { useBreakpoint } from "@core/hooks/useBreakpoint";

export type Props = {
  onClick: () => void;
};

export function VideoUIControlsEndMeeting({ onClick }: Props) {
  const isMdScreen = useBreakpoint("md");

  return (
    <Button iconComponent={PhoneOff} onClick={onClick} destructive theme="dark">
      {isMdScreen ? "Leave" : ""}
    </Button>
  );
}

export default VideoUIControlsEndMeeting;
